export default __webpack_public_path__ + "src/assets/icn-sad-wallet.f0aff8b0ee149c0c8d0c997e9a4c1873.svg";